import {createFeatureSelector, createSelector} from "@ngrx/store";

import {TRUNK_NOTICE_FEATURE_KEY, trunkNoticeAdapter, State} from "./trunk-notice.reducer";
import {StateToQuery} from "../../../utility/abstract-index/state-to-query.func";

// Lookup the 'TrunkNotice' feature state managed by NgRx
export const getTrunkNoticeState = createFeatureSelector<State>(TRUNK_NOTICE_FEATURE_KEY);

const { selectAll, selectEntities } = trunkNoticeAdapter.getSelectors();

export const getTrunkNoticeLoaded = createSelector(
  getTrunkNoticeState,
  (state: State) => state.loaded
);

export const getTrunkNoticeError = createSelector(
  getTrunkNoticeState,
  (state: State) => state.error
);

export const getTrunkNoticeTotal = createSelector(
  getTrunkNoticeState,
  (state: State) => state.total
);

export const getTrunkNoticePage = createSelector(
  getTrunkNoticeState,
  (state: State) => state.page
);

export const getTrunkNoticeTerm = createSelector(
  getTrunkNoticeState,
  (state: State) => state.term
);

export const getTrunkNoticeSort = createSelector(
  getTrunkNoticeState,
  (state: State) => state.sort
);

export const getTrunkNoticeQuery = createSelector(
  getTrunkNoticeState,
  (state: State) => StateToQuery(state)
);

export const getAllTrunkNotice = createSelector(
  getTrunkNoticeState,
  (state: State) => selectAll(state)
);

export const getTrunkNoticeEntities = createSelector(
  getTrunkNoticeState,
  (state: State) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getTrunkNoticeState,
  (state: State) => state.selectedId
);

export const getSelected = createSelector(
  getTrunkNoticeEntities,
  getSelectedId,
  (entities, selectedId) => (selectedId ? entities[selectedId] : undefined)
);
